import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DevSettingsService } from 'core/services/dev-settings.service';
import { IanTranslateService } from 'core/services/ian-core-singleton.service';
import { _formatSqlQuery } from '../../aux_helper_functions';

export interface PinCardDialogData {
  query: string;
  defaultTitle?: string;
  userPrompt?: string;
}

export interface PinCardDialogResult {
  confirmed: boolean;
  title: string;
  userPrompt?: string;
}

@Component({
  selector: 'pin-card-dialog',
  template: `
    <h1 mat-dialog-title>Anclar al Dashboard</h1>
    <div mat-dialog-content>
      <div *ngIf="data.userPrompt" style="margin-bottom: 16px;">
        <div style="margin-bottom: 8px; font-weight: 500; color: rgba(0, 0, 0, 0.7);">{{ getUserQueryLabel() }}</div>
        <pre class="query-display">{{ data.userPrompt }}</pre>
      </div>

      <div *ngIf="canUseDevMode()">
        <div style="margin-bottom: 8px; font-weight: 500; color: rgba(0, 0, 0, 0.7);">{{ getSqlQueryLabel() }}</div>
        <pre class="query-display">{{ getFormattedQuery() }}</pre>
      </div>
    </div>
    <div mat-dialog-actions align="end">
      <button mat-button (click)="cancel()">{{ getCancelText() }}</button>
      <button mat-raised-button color="primary" (click)="confirm()">{{ getConfirmText() }}</button>
    </div>
  `,
  styles: [
    `
      .query-display {
        background: #f5f5f5;
        padding: 12px;
        border-radius: 4px;
        font-family: monospace;
        font-size: 12px;
        line-height: 1.4;
        max-height: 200px;
        overflow-y: auto;
        white-space: pre-wrap;
        word-break: break-all;
        border: 1px solid rgba(0, 0, 0, 0.12);
      }

      mat-form-field {
        width: 100%;
      }
    `,
  ],
})
export class PinCardDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<PinCardDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PinCardDialogData,
    private translate: IanTranslateService,
    private devSettings: DevSettingsService
  ) {}

  cancel(): void {
    this.dialogRef.close({ confirmed: false, title: '', userPrompt: '' });
  }

  confirm(): void {
    // El título se generará automáticamente con IA, solo confirmamos
    this.dialogRef.close({
      confirmed: true,
      title: '', // Se generará con IA
      userPrompt: this.data.userPrompt || '',
    });
  }

  // Translation methods
  getUserQueryLabel(): string {
    return this.translate.instant('DATA_VISUALIZATION.PIN_DIALOG.USER_QUERY') || 'Consulta del Usuario:';
  }

  getSqlQueryLabel(): string {
    return this.translate.instant('DATA_VISUALIZATION.PIN_DIALOG.SQL_QUERY') || 'Query SQL:';
  }

  getCancelText(): string {
    return this.translate.instant('DATA_VISUALIZATION.PIN_DIALOG.CANCEL') || 'Cancelar';
  }

  getConfirmText(): string {
    return this.translate.instant('DATA_VISUALIZATION.PIN_DIALOG.CONFIRM') || 'Confirmar';
  }

  getFormattedQuery(): string {
    return _formatSqlQuery(this.data.query);
  }

  canUseDevMode(): boolean {
    return this.devSettings.__canUseDevMode();
  }
}
